import React from 'react';

type SkeletonProps = {
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
  width?: string | number;
  height?: string | number;
};

export default function Skeleton({
  className = '',
  variant = 'text',
  width,
  height,
}: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;

  let variantClass = '';
  if (variant === 'circle') {
    variantClass = 'rounded-full';
  } else if (variant === 'rect') {
    variantClass = 'rounded-rustic';
  } else {
    variantClass = 'rounded h-4'; // default text line
  }

  return (
    <div
      style={style}
      className={`animate-pulse bg-wheat/40 dark:bg-wood/20 ${variantClass} ${className}`}
    />
  );
}
